import { render, staticRenderFns } from "./ImportPoliciesButton.vue?vue&type=template&id=6b5a5a2e"
import script from "./ImportPoliciesButton.vue?vue&type=script&lang=ts"
export * from "./ImportPoliciesButton.vue?vue&type=script&lang=ts"
import style0 from "./ImportPoliciesButton.vue?vue&type=style&index=0&id=6b5a5a2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports